import React, { useState } from 'react';
import Timmer from './Timmer';
import BirthDay from './BirthDay';
import Graph from './Graph';
import './DashboardPage.css';

const DashboardPage: React.FC = () => {
  const [isClockedIn, setIsClockedIn] = useState(false);
  const [TakeaBreak, setTakeaBreak] = useState(false);
  const [isTimmerReady, setIsTimmerReady] = useState(false);



  return (
    <>
      <div className="p-6 grid grid-cols-12 gap-0 overflow-hidden">
        <div className="col-span-8 p-6">
          <Timmer
            setIsClockedIn={setIsClockedIn}
            isClockedIn={isClockedIn}
            TakeaBreak={TakeaBreak}
            setTakeaBreak={setTakeaBreak}
            setIsTimmerReady={setIsTimmerReady}
          />
        </div>
        <div className="col-span-4 right-panel-column">
          <BirthDay />
        </div>
      </div>

      <Graph />
    </>
  );
};

export default DashboardPage;
